import React, { useState } from "react";
import { HiMenuAlt4, HiX } from "react-icons/hi";

import { images } from "../../constants";
import ThemeToggle from "../ThemeToggle/ThemeToggle";
import "./Navbar.scss";
import { useNavigate, useLocation } from "react-router-dom";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const fromResume = new URLSearchParams(location.search).get('from') === 'resume';
  const homePath = fromResume ? '/?from=resume' : '/';

  const handleMenuToggle = () => {
    console.log('Menu toggle clicked, current state:', toggle);
    const newState = !toggle;
    setToggle(newState);
  };

  const handleMenuItemClick = () => {
    setToggle(false);
  };

  return (
    <nav className="app__navbar">
      <div className="app__navbar-logo" onClick={() => navigate(homePath)}>
        <img src={images.faceLogo} alt="logo" />
      </div>
      <ul className="app__navbar-links">
        {["home", "about", "work", "experience", "skills", "contact"].map((item) => (
          <li className="app__flex p-text" key={`link-${item}`}>
            <div />
            <a
              href={`/#${item}`}
              onClick={e => {
                e.preventDefault();
                if (window.location.pathname !== "/") {
                  // Navigate to home first, then scroll after a short delay
                  navigate(homePath);
                  setTimeout(() => {
                    const el = document.getElementById(item);
                    if (el) {
                      el.scrollIntoView({ behavior: "smooth" });
                    }
                  }, 100);
                } else {
                  // Already on home page, scroll directly
                  const el = document.getElementById(item);
                  if (el) {
                    el.scrollIntoView({ behavior: "smooth" });
                  }
                }
              }}
            >
              {item}
            </a>
          </li>
        ))}
      </ul>

      <div className="app__navbar-theme">
        <ThemeToggle />
      </div>

       <div className="app__navbar-menu">
        <HiMenuAlt4 onClick={handleMenuToggle} />

        {toggle && (
          <div
          >
             <HiX onClick={handleMenuToggle} />
            <ul>
              {["home", "about", "work", "experience", "skills", "contact"].map((item) => (
                <li key={item}>
                  <a 
                    href={`#${item}`} 
                    onClick={e => {
                      e.preventDefault();
                      handleMenuItemClick();
                      if (window.location.pathname !== "/") {
                        navigate(homePath);
                        setTimeout(() => {
                          const el = document.getElementById(item);
                          if (el) {
                            el.scrollIntoView({ behavior: "smooth" });
                          }
                        }, 100);
                      } else {
                        const el = document.getElementById(item);
                        if (el) {
                          el.scrollIntoView({ behavior: "smooth" });
                        }
                      }
                    }}
                  >
                    {item}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>
     
    </nav>
  );
};

export default Navbar;
